<template>
  <card>
    <b-row align-v="center" slot="header">
      <b-col cols="8">
        <h3 class="mb-0">{{ $t("message.order_id") }}: {{ orderid }}</h3>
      </b-col>
    </b-row>

    <h6 class="heading-small text-muted mb-4">{{ $t("message.client") }}</h6>

    <div class="pl-lg-4">
      <b-row>
        {{ $t("message.any_company") }}: {{ order.bestForetag }}
        <br />
        {{ $t("message.name") }}: {{ order.bestFnamn }} {{ order.bestEnamn }}
        <br />
        {{ $t("message.address") }}: {{ order.bestAdress }}
        <br />
        {{ $t("message.postnumber") }}: {{ order.bestPostcode }} {{ $t("message.city") }}: {{ order.bestCity }}
        <br />
      </b-row>
      <b-row>
        {{ $t("message.telephone") }}: {{ order.bestTel }}
        <br />
        {{ $t("message.mobilephone") }}: {{ order.bestMob }}
        <br />
        {{ $t("message.fax") }}: {{ order.bestFax }}
        <br />
        {{ $t("message.email") }}: {{ order.bestEmail }}
        <br />
      </b-row>
    </div>
    <hr class="my-4" />

    <!-- Address -->
    <h6 class="heading-small text-muted mb-4">{{ $t("message.company_information") }}</h6>

    <div class="pl-lg-4">
      <b-row>
        <b-col lg="3">
          <h6 class="heading-small text-muted mb-4">{{ $t("message.company_name") }}</h6>
          {{ order.bolagsnamn1 }}
          <br />
          {{ order.bolagsnamn2 }}
          <br />
          {{ order.bolagsnamn3 }}
        </b-col>
        <b-col lg="3">
          <h6 class="heading-small text-muted mb-4">{{ $t("message.address") }}</h6>
          {{ order.bolagAdress }}
          <br />
          {{ order.bolagPostcode }} {{ order.bolagCity }}
          <br />
          {{ $t("message.state") }}: {{ order.bolagSate }}
        </b-col>
        <b-col lg="3">
          <h6 class="heading-small text-muted mb-4">{{ $t("message.share_capital") }}</h6>
          {{ order.aktieKapital }} kr
          <br />
          {{ $t("message.number_of_shares") }}: {{ order.aktiesKvotvarde }}
        </b-col>
        <b-col lg="3">
          <h6 class="heading-small text-muted mb-4">{{ $t("message.financial_year") }}</h6>
          <span v-if="order.rakenskapsar == 1">1/1 - 31/12</span>
          <span v-if="order.rakenskapsar == 2">1/5 - 30/4</span>
          <span v-if="order.rakenskapsar == 3">1/7 - 30/6</span>
          <span v-if="order.rakenskapsar == 4">1/9 - 31/8</span>
          <span v-if="order.rakenskapsar == 5">{{ $t("message.other") }}: {{ order.annat }}</span>
        </b-col>
      </b-row>
    </div>

    <hr class="my-4" />
    <!-- Description -->
    <h6 class="heading-small text-muted mb-4">{{ $t("message.busness_description") }}</h6>
    <div class="pl-lg-4">{{ order.verksamhet }}</div>

    <hr class="my-4" />
    <!-- Description -->
    <h6 class="heading-small text-muted mb-4">{{ $t("message.board_n_shareholders") }}</h6>
    <div class="pl-lg-4">
      <div
        v-for="Styrelsemedlem in order.styrelsemedlems"
        :key="Styrelsemedlem.id"
      >
        <h6 class="heading-small text-muted mb-4">{{ $t("message.board_member") }}</h6>
        {{ Styrelsemedlem.fname }} {{ Styrelsemedlem.lname }}
        <BR />
        {{ Styrelsemedlem.personalnr }}
        <BR />
        {{ Styrelsemedlem.address }}
        <br />
        {{ Styrelsemedlem.coaddress }}
        <br />
        {{ Styrelsemedlem.postnumber }} {{ Styrelsemedlem.city }}
        <BR />

        <div v-if="Styrelsemedlem.ledamot == '1'">{{ $t("message.commissioner") }}</div>
        <div v-if="Styrelsemedlem.suppleant == '1'">{{ $t("message.deputy") }}</div>
        <div v-if="Styrelsemedlem.ordforande == '1'">{{ $t("message.president") }}</div>
        <div v-if="Styrelsemedlem.vd == '1'">{{ $t("message.ceo") }}</div>
        <div v-if="Styrelsemedlem.extern_vd == '1'">{{ $t("message.external_ceo") }}</div>
        <div v-if="Styrelsemedlem.firmatecknare == '1'">
          {{ $t("message.external_signatory") }}
        </div>
        <div v-if="Styrelsemedlem.person == '1'">{{ $t("message.notifiable") }}</div>
        <div v-if="Styrelsemedlem.aktier == '1'">{{ $t("message.shareholder") }}</div>
        <div v-if="Styrelsemedlem.aktier != ''">
          {{ $t("message.number_of_shares2") }} {{ Styrelsemedlem.txt_antal }}
        </div>
        <br />
        <br />
      </div>

      <div v-for="Company in order.companies" :key="Company.id">
        <h6 class="heading-small text-muted mb-4">{{ $t("message.company") }}</h6>
        {{ Company.companyname }}
        <BR />
        {{ Company.orgnr }}
        <BR />
        {{ Company.address }} {{ Company.postnumber }}
        <BR />
        {{ Company.city }}
        <BR />
        {{ $t("message.number_of_shares2") }} {{ Company.txt_antal }}
        <br />
        <br />
      </div>
    </div>

    <hr class="my-4" />
    <!-- Description -->
    <h6 class="heading-small text-muted mb-4">{{ $t("message.Company_drawing") }}</h6>
    <div v-if="order.firmateckning" class="pl-lg-4">
      <span v-if="order.firmateckning.Styrelsen == '1'">{{ $t("message.the_board") }}</span>
      <span v-if="order.firmateckning.Styrelseledamoterna == 1"
        >{{ $t("message.board_members_are_seprate") }}</span
      >
      <span v-if="order.firmateckning.Styrelseledamoten == '1'"
        >{{ $t("message.board_members_deputy_board_members_are_seperate") }}</span
      >
      <span v-if="order.firmateckning.Forening == '1'"
        >{{ $t("message.two_board_members_together") }}</span
      >
      <span v-if="order.firmateckning.Annat == '1'">{{ $t("message.other") }}</span>
      <br />
      <span v-if="order.firmateckning.Annat == '1'">{{
        order.annat_firmateckn
      }}</span>
    </div>

    <hr class="my-4" />
    <!-- Description -->
    <h6 class="heading-small text-muted mb-4">{{ $t("message.auditor") }}</h6>
    <div class="pl-lg-4">
      <div v-if="order.revisor">
        <div
          id="Revisorlist"
          :key="single_revisor.id"
          v-for="single_revisor in order.revisor"
        >
          <b-row>
            <b-col lg="12">
              <div v-if="single_revisor.funktion == '3'">
                <div>
                  <div>{{ $t("message.auditing_company") }}</div>
                  <div>{{ single_revisor.byra1 }}</div>
                  <div>{{ single_revisor.organisationsnummer }}</div>
                  <div>
                    {{ single_revisor.or_postadress }}
                    {{ single_revisor.or_postnummer }}
                    {{ single_revisor.or_ort }}
                  </div>
                </div>
                <div></div>
              </div>
              <div>
                <div v-if="single_revisor.funktion == 3">
                  {{ $t("message.principal_auditor") }}
                </div>
                <div v-if="single_revisor.funktion == 2">{{ $t("message.deputy_auditor") }}</div>
                <div v-if="single_revisor.funktion == 1">{{ $t("message.auditor") }}</div>
                <div>
                  {{ single_revisor.fname }}
                  {{ single_revisor.lname }}
                </div>
                <div>
                  <div>{{ single_revisor.personalnr }}</div>
                  <div v-if="single_revisor.funktion != 3">
                    {{ single_revisor.byra }}
                  </div>
                  <div>
                    {{ single_revisor.address }}
                    {{ single_revisor.postnumber }}
                    {{ single_revisor.city }}
                    <BR />
                    <BR />
                  </div>
                </div>
                <div v-if="single_revisor.funktion == 0">
                  {{ $t("message.auditor_must_not_be_registerd") }}
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <hr class="my-4" />
    <!-- Description -->
    <h6 class="heading-small text-muted mb-4">{{ $t("message.Forbehall") }}</h6>
    <div class="pl-lg-4">
      <div v-if="order.hembud == '1'" class>{{ $t("message.sharpened_home_delivery") }}</div>
      <div v-if="order.hembud == '2'" class>{{ $t("message.family_law_exception") }}</div>
      <div v-if="order.hembud == '3'" class>{{ $t("message.pre_order_reservation") }}</div>
      <div v-if="order.hembud == '4'" class>{{ $t("message.subject_to_consent") }}</div>
      <div v-if="order.hembud == '5'" class>
        {{ $t("message.home_delivery_for_family_law_prisoners") }}
      </div>
      <div v-if="order.hembud == '6'" class>
        {{ $t("message.pre_purcashe_home_delivery_for_family_law_prisoners") }}
      </div>
      <div v-if="order.hembud == '7'" class>{{ $t("message.nothing") }}</div>
      <div v-if="order.onskemal == '1'" class>
        {{ $t("message.other_requests") }} : {{ order.ovriga_onskemal }}
      </div>
    </div>

    <hr class="my-4" />
    <!-- Description -->
    <h6 class="heading-small text-muted mb-4">{{ $t("message.other2") }}</h6>
    <div class="pl-lg-4">
      <div v-if="order.is_refer == 1">
        {{ order.refer }}
        <br />
        <h6 class="heading-small text-muted mb-4">
        {{ $t("message.elected_board_member") }}: 
        </h6>
        {{ order.board_member }}
      </div>
      <div v-else>
        <h6 class="heading-small text-muted mb-4">{{ $t("message.apply_new_account") }}:</h6>
                    <div v-if="order.app_new_account == 1" ><span v-html="$t('message.seb_application')"></span></div>
                  <div v-if="order.app_new_account == 2" ><span v-html="$t('message.northmill_application')"></span></div>
                  <div v-if="order.app_new_account == 3" ><span v-html="$t('message.valfri_application')"></span></div>
                  <div v-if="order.app_new_account == 4" ><span v-html="$t('message.lunar_application')"></span></div>
        <h6 class="heading-small text-muted mb-4">
        {{ $t("message.elected_board_member") }}:
      </h6>
        <div>
          {{ order.board_member }}
        </div>
      <h6 class="heading-small text-muted mb-4">
      {{ $t("message.purchase_and_change_documents_for_the_new") }}:
      </h6>
      <div v-if="order.skickasVia == '1'">{{ $t("message.email") }}</div>
      <div v-if="order.skickasVia == '4'">
      {{ $t("message.email_with_digital_signing") }}
      </div>
      <div v-if="order.skickasVia == '3'">{{ $t("message.post") }}</div>
      </div>
      <h6 class="heading-small text-muted mb-4">
      {{ $t("message.cost_for_warehouse_company") }}:
      </h6>
      <div v-if="order.faktureras == '1'">{{ $t("message.the_customer") }}</div>
      <div v-if="order.faktureras == '2'">{{ $t("message.new_wherehouse_company") }}</div>
      <div v-if="order.faktureras == '3'">{{ $t("message.parent_company") }}</div>

      <h6 class="heading-small text-muted mb-4">
        {{ $t("message.company_doc_required_format") }}:
      </h6>
      <div v-if="order.aktiebok == '1'">{{ $t("message.digital_without_cert") }}</div>
      <div v-if="order.aktiebok == '2'">
        {{ $t("message.physical_in_company_folder") }}
      </div>
      <div v-if="order.aktiebok == '3'">
        {{ $t("message.physical_in_company_folder_with_share_cert") }}
      </div>
      <div>
        {{ order.overigt }}
        <br />
        <br />
      </div>
    </div>
    <hr class="my-4" />
    <div>
      <base-button
        @click="copySurvey()"
        v-if="order.endDate"
        block
        type="primary"
        >{{ $t("message.copy_order") }}</base-button
      >
      <base-button @click="completeSurvey()" v-else block type="primary"
        >{{ $t("message.complete_order") }}</base-button
      >
    </div>
  </card>
</template>
<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";
import qs from "qs";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.$cookies.config("30d");
export default {
  data() {
    return {
      user: {
        company: "Creative Code Inc.",
        username: "michael23",
        email: "",
        firstName: "Mike",
        lastName: "Andrew",
        address: "Bld Mihail Kogalniceanu, nr. 8 Bl 1, Sc 1, Ap 09",
        city: "New York",
        country: "USA",
        postalCode: "",
        aboutMe: `Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo.`,
      },
      orderid: 0,
      order: [],
    };
  },
  mounted() {
    //code
    //console.log("order id in detail 2 " + this.$route.params.id);
    this.orderid = this.$route.params.id;
    if ($cookies.isKey("userid")) {
      var userid = $cookies.get("userid");
      var token = $cookies.get("token");
      if (userid == 11) {
        userid = 0;
      }
      Vue.axios
        .get("/app/getsingleorder/" + this.orderid + "/" + userid + "/" + token)
        .then(({ data }) => {
          if (data.status == 1) {
            console.log("Styrelsemedlem");
            console.log(data.Styrelsemedlem);

            let Styrelsemedlems = [];
            let Companies = [];
            for (let i = 0; i < data.Styrelsemedlem.length; i++) {
              Styrelsemedlems.push({
                id: i,
                fname: data.Styrelsemedlem[i].fname,
                tname: data.Styrelsemedlem[i].tname,
                lname: data.Styrelsemedlem[i].ename,
                personalnr: data.Styrelsemedlem[i].personnr,
                address: data.Styrelsemedlem[i].adress,
                coaddress: data.Styrelsemedlem[i].coadress,
                postnumber: data.Styrelsemedlem[i].postnr,
                city: data.Styrelsemedlem[i].ort,

                fname_Im: data.Styrelsemedlem[i].fname_Im,
                tname_Im: data.Styrelsemedlem[i].tname_Im,
                lname_Im: data.Styrelsemedlem[i].ename_Im,
                personalnr_Im: data.Styrelsemedlem[i].personnr_Im,
                address_Im: data.Styrelsemedlem[i].adress_Im,
                coaddress_Im: data.Styrelsemedlem[i].coadress_im,
                postnumber_Im: data.Styrelsemedlem[i].postnr_Im,
                city_Im: data.Styrelsemedlem[i].ort_Im,

                show: false,
                ledamot: data.Styrelsemedlem[i].ledamot,
                suppleant: data.Styrelsemedlem[i].suppleant,
                ordforande: data.Styrelsemedlem[i].ordforande,
                vd: data.Styrelsemedlem[i].vd,
                extern_vd: data.Styrelsemedlem[i].extern_vd,
                firmatecknare: data.Styrelsemedlem[i].extern_firmatecknare,
                person: data.Styrelsemedlem[i].delgivningsbar_person,
                aktier: data.Styrelsemedlem[i].aktier,
                txt_antal: data.Styrelsemedlem[i].antalaktier,
                id: data.Styrelsemedlem[i].id,
                ispartner: data.Styrelsemedlem[i].ispartner,
              });
            }

            console.log(Styrelsemedlems);

            for (let i = 0; i < data.company.length; i++) {
              Companies.push({
                id: i,
                companyname: data.company[i].companyname,
                orgnr: data.company[i].orgnr,
                address: data.company[i].address,
                postnumber: data.company[i].postnumber,
                city: data.company[i].city,
                show: false,
                txt_antal: data.company[i].antalaktier,
                id: data.company[i].id,

                companyname_im: data.company[i].companyname_im,
                orgnr_im: data.company[i].orgnr,
                address_im: data.company[i].address_im,
                postnumber_im: data.company[i].postnumber_im,
                city_im: data.company[i].city_im,
              });
            }

            var firmateckning = {
              Styrelsen: 0,
              Styrelseledamoterna: 0,
              Styrelseledamoten: 0,
              Forening: 0,
              Annat: 0,
            };
            var annat_firmateckn = 0;
            if (this.IsJsonString(data.order.firmateckn_styrelsen)) {
              console.log("firm");
              console.log(data.order.firmateckn_styrelsen);
              let Firmateckning = JSON.parse(data.order.firmateckn_styrelsen);
              console.log(Firmateckning);
              firmateckning = Firmateckning; //this.Styrelsemedlems
              annat_firmateckn = data.order.annat_firmateckn;
            }

            this.order = {
              bestForetag: data.order.bestForetag,
              bestFnamn: data.order.bestFnamn,
              bestEnamn: data.order.bestEnamn,
              bestAdress: data.order.bestAdress,
              bestPostcode: data.order.bestPostcode,
              bestCity: data.order.bestCity,
              bestTel: data.order.bestTel,
              bestMob: data.order.bestMob,
              bestFax: data.order.bestFax,
              bestEmail: data.order.bestEmail,
              bolagsnamn1: data.order.bolagsnamn1,
              bolagsnamn2: data.order.bolagsnamn2,
              bolagsnamn3: data.order.bolagsnamn3,
              bolagAdress: data.order.bolagAdress,
              bolagPostcode: data.order.bolagPostcode,
              bolagCity: data.order.bolagCity,
              bolagSate: data.order.bolagSate,
              bolagEmail: data.order.bolagEmail,
              aktieKapital: data.order.aktieKapital,
              aktiesKvotvarde: data.order.aktiesKvotvarde,
              rakenskapsar: data.order.rakenskapsar,
              annat: data.order.annat,
              verksamhet: data.order.verksamhet,
              styrelsemedlems: Styrelsemedlems,
              companies: Companies,
              firmateckning: firmateckning,
              annat_firmateckn: annat_firmateckn,
              is_refer: data.order.isrefer,
              refer: data.order.refer,
              app_new_account: data.order.app_new_account,
            };

            //step6
            console.log("revisor ");
            console.log(data.Revisor);
            let Revisor = [];
            for (let i = 0; i < data.Revisor.length; i++) {
              let byra1 = "";
              let byra = "";
              if (data.Revisor[i].funktion == 3) {
                byra1 = data.Revisor[i].byra;
              } else {
                byra = data.Revisor[i].byra;
              }
              Revisor.push({
                byra1: byra1,
                organisationsnummer: data.Revisor[i].orgnr,
                or_postadress: data.Revisor[i].adress_byra,
                or_postnummer: data.Revisor[i].postnr_byra,
                or_ort: data.Revisor[i].ort_byra,
                fname: data.Revisor[i].fname,
                lname: data.Revisor[i].ename,
                personalnr: data.Revisor[i].personnr,
                byra: byra,
                address: data.Revisor[i].adress,
                postnumber: data.Revisor[i].postnr,
                city: data.Revisor[i].ort,
                funktion: data.Revisor[i].funktion,
                id: data.Revisor[i].id,
              });
            }
            console.log(Revisor);
            this.order.revisor = Revisor;
            this.order.revisor_type = data.order.revisor_type;

            this.order.hembud = data.order.hembud;

            if (data.order.ovriga_onskemal) {
              this.order.onskemal = 1;
            } else {
              this.order.onskemal = 0;
            }
            this.order.ovriga_onskemal = data.order.ovriga_onskemal;

            //step8
            console.log("skickasVia");
            console.log(data.order.skickasVia);

            this.order.skickasVia = data.order.skickasVia;
            this.order.faktureras = data.order.faktureras;
            this.order.aktiebok = data.order.aktiebok;
            this.order.ovrigt = data.order.ovrigt;
            this.order.board_member = data.order.board_member;
            this.order.endDate = data.order.endDate;
            this.order.orderToken = data.order.order_token;
          } else {
            //no action
            this.$router.push({ name: "login" });
          }
        });
    } else {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    copySurvey: function () {
      var userid = $cookies.get("userid");
      var token = $cookies.get("token");
      Vue.axios
        .post(
          "/app/copy_survey",
          qs.stringify({
            order_id: this.orderid,
            order_token: this.order.orderToken,
            userid: userid,
            token: token,
          })
        )
        .then(({ data }) => {
          this.$router.push({ name: "mina_sidor" });
        });
    },
    completeSurvey: function () {
      $cookies.set("order_id", this.orderid);
      $cookies.set("order_token", this.order.orderToken);
      if(this.order.is_refer == 1) {
        $cookies.set("refer", "seb");
        window.location.replace("/app/seb/kop-lagerbolag/kontaktperson");
      }
      else{
        $cookies.remove("refer");
        window.location.replace("/app/kop-lagerbolag/kontaktperson");
      }
      //this.$router.push("/app/kop-lagerbolag/kontaktperson");
    },
    IsJsonString: function (str) {
      try {
        if (str != null && str !== undefined) {
          JSON.parse(str);
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    },
    updateProfile() {
      alert("Your data: " + JSON.stringify(this.user));
    },
  },
};
</script>
<style></style>
